import React, { useState, useEffect } from 'react';
import { Table, Row, Col } from 'reactstrap';
import { InputModulos } from '.';
import { convocatoriasAgotadas } from '../../../helpers/convocatorias';

export const Desplegable = ({
  array,
  activity,
  keyArray,
  modulos,
  setIsEnabled,
  setModulos,
  setHoursCounter,
  hoursCounter,
  setTotal,
  setTotal2,
  setTotalSuelto,
  setTotalSuelto2,
  total,
  total2,
  totalSuelto,
  totalSuelto2,
}) => {
  // Preparamos variables necesarias
  const [collapse, setCollapse] = useState(false);
  const [isParentChecked, setIsParentChecked] = useState(false);
  const [completed, setIsCompleted] = useState(false);
  const [isWasted, setIsWasted] = useState(false);

  // Efectos
  useEffect(() => {
    let cont = 0;
    let contConv = 0;

    activity[keyArray].forEach((actividad) => {
      //Comprobar si todas las actividades del módulo tienenen las convocatorias gastadas o están aprobadas
      if (actividad.Nota === 1) {
        cont++;
      }

      if (convocatoriasAgotadas(actividad)) {
        contConv++;
      }
    });

    if (cont === activity[keyArray].length) {
      setIsCompleted(true);
    }

    if (contConv === activity[keyArray].length) {
      setIsWasted(true);
    }
  }, []);

  // Efecto que marca o desmarca el padre según sus hijos
  useEffect(() => {
    let arrCount = 0;

    // Revisamos hijo por hijo si está marcado
    array.forEach((obj) => {
      const value = `${obj.modulo} ${obj.descripcion}`;

      if (modulos.includes(value)) {
        arrCount++;
      }
    });

    // Si están todos marcados, lo marcamos
    if (array.length === arrCount) {
      setIsParentChecked(true);
    } else {
      setIsParentChecked(false);
    }
  }, [modulos]);

  // Función que alterna el collapse
  const toggle = (e) => {
    if (e.target.type !== 'checkbox') {
      setCollapse(!collapse);
    }
  };

  // Función que controla el cambio del checkbox padre
  const handleParentCheckboxChange = () => {
    setIsParentChecked(!isParentChecked);
    let tFinal = 0;
    let tFinalSuelto = 0;
    let tFinal2 = 0;
    let tFinalSuelto2 = 0;
    let hFinal = 0;

    array.forEach((obj) => {
      const value = `${obj.modulo} ${obj.descripcion}`;

      if (!isParentChecked) {
        if (!modulos.includes(value)) {
          const newArr = modulos;
          newArr.push(value);
          setModulos([...newArr]);

          if (!obj.descripcion.includes('Formación en el centro de trabajo')) {
            if (!obj.descripcion.includes('Formación en centros de trabajo')) {
              hFinal = hFinal + parseInt(obj.horas, 10);
            }
          }

          if (obj.curso === 'PRIMERO') {
            tFinal += obj.precio;
            tFinalSuelto += obj.importe_suelto;
          } else {
            tFinal2 += obj.precio;
            tFinalSuelto2 += obj.importe_suelto;
          }
        }
      } else {
        const index = modulos.indexOf(value);

        if (index !== -1) {
          const newArr = modulos;
          newArr.splice(index, 1);
          setModulos([...newArr]);

          if (!obj.descripcion.includes('Formación en el centro de trabajo')) {
            if (!obj.descripcion.includes('Formación en centros de trabajo')) {
              hFinal = hFinal - parseInt(obj.horas, 10);
            }
          }

          if (obj.curso === 'PRIMERO') {
            tFinal -= obj.precio;
            tFinalSuelto -= obj.importe_suelto;
          } else {
            tFinal2 -= obj.precio;
            tFinalSuelto2 -= obj.importe_suelto;
          }
        }
      }

      if (modulos.length > 0) {
        setIsEnabled(false);
      } else {
        setIsEnabled(true);
      }
    });

    hoursCounter = hoursCounter + hFinal;
    setHoursCounter(hoursCounter);
    setTotal(total + tFinal);
    setTotal2(total2 + tFinal2);
    setTotalSuelto2(totalSuelto2 + tFinalSuelto2);
    setTotalSuelto(totalSuelto + tFinalSuelto);
  };

  return (
    <div key={keyArray}>
      <div
        className="border-bottom rounded-top mb-2 px-2 py-2 pe-auto"
        onClick={toggle}
        style={{ backgroundColor: '#eef5f9', cursor: 'pointer' }}
      >
        <Row>
          <Col sm="1">
            <input
              type="checkbox"
              checked={isParentChecked}
              onChange={handleParentCheckboxChange}
              id={activity[keyArray][0].nombre}
              disabled={completed || isWasted}
            />
          </Col>
          <Col sm="9">
            <b>
              {activity[keyArray][0].nombre}
              {completed ? ' - Completado' : ''}{' '}
              {isWasted ? ' - Límite de convocatorias superado' : ''}
            </b>
          </Col>
          <Col sm="2">
            <b
              style={
                activity[keyArray][0].curso === 'PRIMERO' ? { color: 'green' } : { color: 'orange' }
              }
            >
              {activity[keyArray][0].curso === 'PRIMERO' ? 'PRIMER AÑO' : 'SEGUNDO AÑO'}
            </b>
          </Col>
        </Row>
      </div>
      {collapse && (
        <Table responsive borderless>
          <thead>
            <tr>
              <th>Código</th>
              <th>Descripción</th>
              <th>Convocatorias</th>
              <th>Horas</th>
              <th>Precio</th>
              <th>Precio suelto</th>
            </tr>
          </thead>
          <tbody>
            {array.map((obj) => (
              <tr key={obj.codigo}>
                <td
                  style={{ width: '20%' }}
                  className={
                    convocatoriasAgotadas(obj) || obj.Nota === 1 ? 'text-black-50' : ''
                  }
                  id={obj.codigo}
                >
                  <InputModulos
                    totalSuelto2={totalSuelto2}
                    total2={total2}
                    setTotal2={setTotal2}
                    setTotalSuelto2={setTotalSuelto2}
                    setTotalSuelto={setTotalSuelto}
                    totalSuelto={totalSuelto}
                    hoursCounter={hoursCounter}
                    setHoursCounter={setHoursCounter}
                    total={total}
                    setTotal={setTotal}
                    obj={obj}
                    modulos={modulos}
                    setIsEnabled={setIsEnabled}
                    setModulos={setModulos}
                  />{' '}
                  {obj.codigo}
                  {obj.Nota === 1 ? ' - Completado' : ''}
                  {convocatoriasAgotadas(obj)
                    ? ' - Superado el máximo de convocatorias'
                    : ''}
                </td>
                <td
                  style={{ width: '50%' }}
                  className={
                    convocatoriasAgotadas(obj) || obj.Nota === 1 ? 'text-black-50' : ''
                  }
                >
                  {obj.descripcion}
                </td>
                <td
                  style={{ width: '10%' }}
                  className={
                    convocatoriasAgotadas(obj) || obj.Nota === 1 ? 'text-black-50' : ''
                  }
                >
                  {obj.convocatorias}
                </td>
                <td
                  style={{ width: '10%' }}
                  className={
                    convocatoriasAgotadas(obj) || obj.Nota === 1 ? 'text-black-50' : ''
                  }
                >
                  {obj.horas}
                </td>
                <td
                  style={{ width: '10%' }}
                  className={
                    convocatoriasAgotadas(obj) || obj.Nota === 1 ? 'text-black-50' : ''
                  }
                >
                  {obj.precio}€
                </td>
                <td
                  style={{ width: '10%' }}
                  className={
                    convocatoriasAgotadas(obj) || obj.Nota === 1 ? 'text-black-50' : ''
                  }
                >
                  {obj.importe_suelto}€
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </div>
  );
};
